import { render } from "./Salon.vue?vue&type=template&id=41f63d32&scoped=true"
import script from "./Salon.vue?vue&type=script&lang=js"
export * from "./Salon.vue?vue&type=script&lang=js"

import "./Salon.vue?vue&type=style&index=0&id=41f63d32&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f63d32"]])

export default __exports__